import { AllowedLanguages, AllowedThemes } from 'declarations/app.d'
import { AnyAction } from 'redux'

export interface AppState {
  theme: AllowedThemes
  language: AllowedLanguages
}

const initialAppState: AppState = {
  theme: 'light',
  language: 'en'
}

const appReducer = (
  /* istanbul ignore next */
  state: AppState = initialAppState,
  action: AnyAction
): AppState => {
  switch (action.type) {
    default:
      return state
  }
}

export default appReducer
